import { ChangeDetectionStrategy, Component, inject } from '@angular/core';

import { ButtonNeutralComponent } from 'src/app/features/shared/controls/container/button-neutral/button-neutral.component';
import { IconsModule } from 'src/app/features/shared/icons/icons.module';
import { SharedModule } from 'src/app/features/shared/shared.module';
import { TabsDropdownComponent } from '../../../../components/tabs-dropdown-control/tabs-dropdown.component';
import { TabListService } from '../../../../services/tab-list.service';
import { injectRequired } from 'src/app/infrastructure/functions/inject-required.function';
import { loadKey } from 'src/app/infrastructure/services/loading-services/models/loadKey';

@Component({
    selector: 'app-tablist-header',
    templateUrl: './tablist-header.component.html',
    changeDetection: ChangeDetectionStrategy.OnPush,
    host: {
        '(touchstart)': 'emit_touchStart($event)',
        '(touchend)': 'emit_touchEnd($event)',
    },
    standalone: true,
    imports: [
        IconsModule,
        SharedModule,
        ButtonNeutralComponent,
        TabsDropdownComponent,
    ],
    styleUrls: ['./tablist-header.component.scss'],
})
export class TablistHeaderComponent
{
    private readonly _tabListService = injectRequired(TabListService);

    readonly loadKey = loadKey;

    isBeginList$$ = this._tabListService.isBeginList$$;
    isEndList$$ = this._tabListService.isEndList$$;
    hasList$$ = this._tabListService.hasList$$;
    tabIndex$$ = this._tabListService.tabIndex$$;
    tabLabel_next$$ = this._tabListService.tabLabel_next$$;
    tabLabel_previous$$ = this._tabListService.tabLabel_previous$$;
    tabList$$ = this._tabListService.tabList$$;
    tablistDropdown$$ = this._tabListService.tabListDropdown$$;

    emit_btnClick_nexTab(): void {
        this.tab_next()
    }

    emit_btnClick_previousTab(): void {
        this.tab_previous()
    }

    emit_ValueChange(value: number) {
        this.tabIndex_set(value);
    }

    emit_openedChange(opened: boolean): void {
        this._tabListService.dropdownOpen_set(opened);
    }

    emit_touchStart(e: TouchEvent): void {
        this._tabListService.header_swipe(e, 'start');
    }

    emit_touchEnd(e: TouchEvent): void {
        this._tabListService.header_swipe(e, 'end');
    }

    tab_next(): void {
        this._tabListService.tab_next();
    }

    tab_previous(): void {
        this._tabListService.tab_previous();
    }

    tabIndex_set(index: number) {
        this._tabListService.TabIndex = index;
    }

    nextTab_show(): boolean {
        return this.hasList$$() && !this.isEndList$$();
    }
}
